
import { IDictionary } from "../types";
import { api_get, api_post } from "./utils"


const ClockAPI = {
    load: _loadClock,
    listCurrent: _listCurrent,
    listByCollab: _listByCollab,
    clockInCollab: _clockInCollab,
    clockInRequest: _clockInRequest,
    clockOut: _clockOut
};


async function _loadClock(key: string) {
    // Autogenerated
    if (!key) {
        return null;
    }
    return api_get("/clock/" + key).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}


async function _listByCollab(collabKey="", identityKey="", cursor: string) {
    let url = '/clock/by-collab?';
    if(collabKey) {
        url += 'collab=' + collabKey + '&';
    }
    if(identityKey) {
        url += 'identity=' + identityKey + '&';
    }

    if (cursor) { url += 'cursor=' + cursor; }
    return api_get(url).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}


async function _clockIn(url: string, params: IDictionary) {
    return api_post(url, params)
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        })
        .catch((err) => {
            console.error("Error starting clock: %o", err);
            throw err;
        });

}

async function _listCurrent() {
    return api_get('/clock/list/current').then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}

async function _clockInCollab(identity: string, collab: string) {
    return _clockIn('/clock/start/collab', { identity, collab });
}

async function _clockInRequest(identity: string, request: string) {
    return _clockIn('/clock/start/request', { identity, request });
}


async function _clockOut(clockKey: string) {
    return api_post('/clock/end', { clock: clockKey })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}

export default ClockAPI;
